// Read-only wrapper for HPC Management assignment detail view
import React from 'react';
import { ChevronLeft, Users } from 'lucide-react';
import AssignmentDetailView from './AssignmentDetailView';

const HPCAssignmentDetailView = ({ 
  assignment, 
  onBack, 
  onViewSubmissions,
  submissionCount = 0 
}) => {
  // Determine stage from assignment data
  const stage = assignment?.stage || '';
  const isPreparatoryStage = stage.toLowerCase().includes('preparatory');
  const isMiddleStage = stage.toLowerCase().includes('middle');

  return (
    <div className="space-y-4">
      {/* Back button */}
      <button 
        onClick={onBack} 
        className="flex items-center gap-2 text-[#D67C2C] hover:underline font-medium"
      >
        <ChevronLeft className="w-4 h-4" /> Back to Activities
      </button>

      {/* View Submissions button at top */}
      <div className="flex justify-end">
        <button
          onClick={() => onViewSubmissions(assignment.assignment_id)}
          className="px-4 py-2 text-sm bg-[#D67C2C] text-white rounded-lg hover:bg-[#c06a25] transition-colors flex items-center gap-2"
        >
          <Users className="w-4 h-4" />
          View Submissions ({submissionCount})
        </button>
      </div>

      {/* Use the existing AssignmentDetailView component in read-only mode */}
      <AssignmentDetailView
        assignment={assignment}
        isPreparatoryStage={isPreparatoryStage}
        isMiddleStage={isMiddleStage}
        onBack={null} // Hide the back button since we have our own
        onEdit={null} // No edit in HPC view
        onViewSubmissions={null} // Hide the view submissions button since we have our own
        onDelete={null} // No delete in HPC view
      />
    </div>
  );
};

export default HPCAssignmentDetailView;
